import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Accordion = function Accordion() {
  return import('~/components/molecules/Accordion.vue');
};

export default {
  name: 'NavItemFolders',
  components: {
    Accordion: Accordion
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};